/**
 * Simple hash-based router.
 * Routes: #folders, #folder/:id, #admin, #admin/actors, #admin/controls, #admin/templates, #admin/users
 */

type RouteHandler = (params: Record<string, string>) => void;

const routes: { pattern: RegExp; handler: RouteHandler }[] = [];

export function route(pattern: string, handler: RouteHandler): void {
  // Convert :param patterns to regex capture groups
  const regex = new RegExp('^' + pattern.replace(/:(\w+)/g, '(?<$1>[^/]+)') + '$');
  routes.push({ pattern: regex, handler });
}

export function navigate(hash: string): void {
  window.location.hash = hash;
}

export function getCurrentRoute(): string {
  return window.location.hash.slice(1) || 'folders';
}

export function startRouter(): void {
  const resolve = () => {
    const hash = getCurrentRoute();
    for (const r of routes) {
      const match = hash.match(r.pattern);
      if (match) {
        r.handler(match.groups || {});
        return;
      }
    }
    // Default to folders
    routes[0]?.handler({});
  };

  window.addEventListener('hashchange', resolve);
  resolve();
}
